import { useEffect, useState } from "react";
import axios from "axios";
import { Radio } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NewsTicker = () => {
  const { t, lang } = useLang();
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/news`)
      .then((r) => setItems(r.data.items || []))
      .catch(() => {});
  }, []);

  const langItems = items.filter((i) => (i.lang || "en") === lang);
  const shown = langItems.length ? langItems : items;

  if (!shown.length) return null;

  return (
    <div data-testid="hero-news-ticker" className="relative bg-slate-900 py-2.5 overflow-hidden border-b border-slate-800">
      <div className="absolute left-0 top-0 bottom-0 z-10 flex items-center gap-2 bg-blue-700 text-white pl-4 sm:pl-6 pr-4">
        <Radio className="w-3 h-3 text-amber-400 live-dot" />
        <span className="text-[9px] font-mono font-bold uppercase tracking-[0.2em] whitespace-nowrap">
          {t("news.tickerLabel")}
        </span>
      </div>
      <div className="marquee-track marquee-track-slow flex w-max items-center pl-40">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center shrink-0" aria-hidden={copy === 1}>
            {shown.map((n) => (
              <a
                key={`${copy}-${n.id}`}
                href={n.link}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center group"
              >
                <span className="text-xs font-semibold text-slate-200 group-hover:text-amber-300 transition-colors px-5 whitespace-nowrap">
                  {n.title}
                </span>
                <span className="text-[9px] font-mono font-bold text-slate-500 uppercase tracking-wider whitespace-nowrap">
                  {n.source}
                </span>
                <span className="mx-5 w-1 h-1 rounded-full bg-amber-400 photon-dot" />
              </a>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
